import { createFeatureSelector, createSelector, createSelectorFactory } from '@ngrx/store';
import * as fromPE from '../fromPe.barrel';
import { EquipmentType, PEEquipmentProduct, PEFittingProduct } from 'src/app/models';
import { findIndex, tap } from 'rxjs';

const state = createFeatureSelector<fromPE.State>(fromPE.peFeatureKey);

export const selectPipeSizes = createSelector(state, state => state.pipeSizes);
export const selectFilterResults = createSelector(state, state => state.fittingsResult);
export const selectFilter = createSelector(state, state => state.peFilter);
export const selectActiveFittings = createSelector(state, state => state.activeFittings || []);
export const selectActiveFittingsPartNumbers = createSelector(selectActiveFittings, fittings => fittings.map(f => f.partNumber));

export const selectPipeSizesForSelectedMeasurement = createSelector(selectPipeSizes, selectFilter, (sizes, selections) => sizes.filter(f => (selections.measurement || -1) === 2 ? f.text?.endsWith('mm') : (selections.measurement || -1) === 1 ? f.text?.endsWith('in') : []));
export const selectLoaders = createSelector(state, state => state.loaders);

// export const selectEquipmentSelections = createSelector(state, state => ({ ...state.equipmentFilter, equipmentType: state.equipmentFilter?.familyID === 6 ? EquipmentType.Tapping : state.equipmentFilter?.familyID === 9 ? EquipmentType.Plugging : EquipmentType.Tapping }));
export const selectEquipmentResults = createSelector(state, selectFilter, (state, peFilter) => {
  if ((peFilter.sizes || []).length < 1) return state.equipmentResult;
  return state.equipmentResult.filter(equipment => {
    const size = equipment.peEquipmentSizes.find(f => (peFilter.sizes || [])?.includes(f.peSizeID));
    return !!size;
  })
});

// export const selectAccessorySelections = createSelector(state, state => state.accessoryFilter);
export const selectAccessoryResults = createSelector(state, selectFilter, (state, fittingSelections) => { // TODO
  // console.log(accessorySelections, fittingSelections);

  // if (fittingSelections.sizes && fittingSelections.sizes.length > -1) {
  // let res = [];
  // TODO
  // res = state.accessoryResult.filter(f => (f.peEquipmentSizes.map(sizes => sizes.peSizeID).includes(fittingSelections.sizes || -1)));
  // console.log(fittingSelections?.familyID, fittingSelections?.subFamilyID);
  // res = res.filter(f => ((fittingSelections?.familyID || -1) === -1 || f.familyID === fittingSelections?.familyID));
  // res = res.filter(f => ((fittingSelections?.subFamilyID || -1) === -1 || f.subFamilyID === fittingSelections?.subFamilyID));
  //   return res;
  // }

  return state.accessoryResult
  // if (!fittingSelections.size || fittingSelections.size < 0) return state.accessoryResult.filter(f => (!(accessorySelections?.familyID) || f.familyID === accessorySelections?.familyID) && (!(accessorySelections?.subFamilyID) || f.subFamilyID === accessorySelections.subFamilyID));

  // return state.accessoryResult.filter(f => (f.peEquipmentSizes.map(sizes => sizes.peSizeID).includes(fittingSelections.size || -1)) && (!(accessorySelections?.familyID) || f.familyID === accessorySelections?.familyID) && (!(accessorySelections?.subFamilyID) || f.subFamilyID === (!accessorySelections.subFamilyID ? -1 : +accessorySelections.subFamilyID)));
});

export const selectEquipmentFamiliesTopLevel = createSelector(state, state => state.equipmentFamilies.filter(f => f.childEquipment.length > 0 &&
  ![EquipmentType.Plugging, EquipmentType.Tapping, EquipmentType.Valve, EquipmentType.Completion].includes(f.id || -1)));
export const selectEquipmentSubFamilies = createSelector(state, selectFilter, (state, peFilter) => {
  const family = state.equipmentFamilies.find(f => f.id === peFilter?.familyID);
  if (!family) return [];
  return family.childEquipment || [];
});

// export const selectActiveEquipmentPartNumber = createSelector(state, state => state.activeEquipmentPartNumber);
// export const selectActiveEquipment = createSelector(selectEquipmentResults, selectActiveEquipmentPartNumber, (results, equipment) => results.find(f => f.partNumber === equipment));
export const selectActivePluggingMachinePartNumber = createSelector(state, state => state.activePluggingMachinePartNumber);
export const selectActivePluggingMachine = createSelector(selectEquipmentResults, selectActivePluggingMachinePartNumber, (equips, partNumber) => equips.find(f => f.partNumber === partNumber));

export const selectActiveTappingMachinePartNumber = createSelector(state, state => state.activeTappingMachinePartNumber);
export const selectActiveTappingMachine = createSelector(selectEquipmentResults, selectActiveTappingMachinePartNumber, (equips, partNumber) => equips.find(f => f.partNumber === partNumber));

export const selectActiveValvePartNumber = createSelector(state, state => state.activeValvePartNumber);
export const selectActiveValve = createSelector(selectEquipmentResults, selectActiveValvePartNumber, (equips, partNumber) => equips.find(f => f.partNumber === partNumber));

export const selectActiveCompletionMachinePartNumber = createSelector(state, state => state.activeCompletionMachinePartNumber);
export const selectActiveCompletionMachine = createSelector(selectEquipmentResults, selectActiveCompletionMachinePartNumber, (equips, partNumber) => equips.find(f => f.partNumber === partNumber));

export const selectActiveAccessoryPartNumbers = createSelector(state, (state) => state.activeAccessoryPartNumbers);
export const selectActiveAccessories = createSelector(selectAccessoryResults, selectActiveAccessoryPartNumbers, (accessories, partNumbers) => {
  return accessories.filter(f => partNumbers?.includes(f.partNumber))
});

export const selectActiveEquipment = createSelector(
  selectActivePluggingMachine,
  selectActiveTappingMachine,
  selectActiveValve,
  selectActiveCompletionMachine,
  (plugging, tapping, valve, completion) => {
    // [plugging, tapping, valve, completion]
    let res: PEEquipmentProduct[] = [];
    if (!!plugging) res = res.concat(plugging);
    if (!!tapping) res = res.concat(tapping);
    if (!!valve) res = res.concat(valve);
    if (!!completion) res = res.concat(completion);
    return res;
  });

export const selectTappingEquipmentOptions = createSelector(selectEquipmentResults, res => res.filter(f => f.familyID === EquipmentType.Tapping && f.subEquipmentFamily === null));
export const selectPluggingEquipmentOptions = createSelector(selectEquipmentResults, res => res.filter(f => f.familyID === EquipmentType.Plugging && f.subEquipmentFamily === null));
export const selectValveEquipmentOptions = createSelector(selectEquipmentResults, res => res.filter(f => f.familyID === EquipmentType.Valve && f.subEquipmentFamily === null));
export const selectCompletionEquipmentOptions = createSelector(selectEquipmentResults, res => res.filter(f => f.familyID === EquipmentType.Completion && f.subEquipmentFamily === null));
export const selectMaintenanceKitsEquipmentOptions = createSelector(selectEquipmentResults, res => res.filter(f => f.familyID === EquipmentType.MaintenanceKit && f.subEquipmentFamily === null));

export const selectEquipmentOptions = createSelector(
  selectTappingEquipmentOptions,
  selectPluggingEquipmentOptions,
  selectValveEquipmentOptions,
  selectCompletionEquipmentOptions,
  selectMaintenanceKitsEquipmentOptions,
  (tapping, plugging, valve, completion, kits) => ({ tapping, plugging, valve, completion, kits }));
export const selectIsLoading = (loader: fromPE.Loaders) => createSelector(selectLoaders, loaders => loaders.includes(loader));

export const selectAnyLoader = (qloaders: fromPE.Loaders[]) => createSelector(selectLoaders, loaders => qloaders.filter(l => loaders.includes(l)).length > 0)
